<div *ngIf="!loadError">
  <ng-content></ng-content>
</div>
<div *ngIf="loadError">
  <em>An error occurred, please try reloading the page.</em>
</div>